export default "__VITE_ASSET__DquMaivu__"